import Loading, { LoadingLinear } from "@ingka/loading";

export function ProgressIndicator({
  progressValue,
}: {
  progressValue: number;
}) {
  return (
    <Loading
      labelPosition="center"
      text={progressValue === 100 ? "100%" : `${progressValue}%`}
    >
      <LoadingLinear loadingMax={100} loadingValue={progressValue} />
    </Loading>
  );
}
